import axios from 'axios'

import PadraoService from '@/modules/services/padrao.service'
import * as msg from '../mensagens/indicacoes.msg'

import ApiRotas from '@/modules/services/rotas.api'
import ServiceHandler from '@/modules/services/handler/service.handler'
import MensagensHelper, { MSG_ALERTA } from '@/utils/mensagens.helper'

class IndicacoesService extends PadraoService {
  constructor() {
    // Rota, Biblioteca de mensagens
    super('indicacoes', msg)
  }

  async retornaAguardandoContato(filial, pagina = 0) {
    const params = pagina === 0 ? { params: { filial } } : { params: { p: pagina, filial } }
    try {
      const retorno = await axios.get(`${ApiRotas}/${this.rota}/pendentes`, params)
      if (retorno.data) {
        return retorno.data
      }

      throw MensagensHelper.gerar(MSG_ALERTA, this.msgs.NAO_ENCONTRADO)
    } catch (error) {
      throw ServiceHandler.validar(error)
    }
  }
}

export default new IndicacoesService()
